export default {"src":"/_next/static/media/frame2.dfc3ee9d.svg","height":109,"width":308,"blurWidth":0,"blurHeight":0};